<div class="finder-layout" [ngClass]="{'loading': !loaded}">
    <!-- Header -->
    <div class="finder-header">
        <ng-content select=".header"></ng-content>
    </div>
    <!-- Loading Spinner -->
    <!-- Hide the spinner if we are in native (isNativeEmbedded = true).
    Remove this once mobile team puts a white background behind their spinner to hide our
    page while it loads. Ticket: [PRO-357679] -->
    <finder-loading-spinner *ngIf="!loaded && !isNativeEmbedded"></finder-loading-spinner>
    <!-- Actual Content -->
    <div class="finder-content">
        <finder-system-error  *ngIf="error" [status]="error.status" [bundle]="languageBundle"></finder-system-error>
        <p *ngIf="error?.error?.myIdGated" class="gated-myid-error">
            {{ error.error.myIdGatedMessage }}
        </p>
        <ng-content select=".content"></ng-content>
    </div>
    <!-- Footer -->
    <div class="finder-footer">
        <ng-content select=".footer"></ng-content>
    </div>
</div>
